import { queryOptions } from '@tanstack/react-query'

import { segmentsApi, type SegmentsScope } from './segmentsApi'

export const segmentsQueries = {
  all: () => ['segments'] as const,
  lists: () => [...segmentsQueries.all(), 'list'] as const,
  list: (scope: SegmentsScope) =>
    queryOptions({
      queryKey: [...segmentsQueries.lists(), scope],
      queryFn: ({ signal }) => segmentsApi.getSegments(scope, { signal }),
    }),
  preview: () =>
    queryOptions({
      queryKey: [...segmentsQueries.all(), 'preview'],
      queryFn: ({ signal }) => segmentsApi.getPreview({ signal }),
    }),
}
